// src/components/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getRoleType } from './RoleBasedRedirect/getRoleBasedRedirect';

import Sidebar from './Sidebar';
import './Layout.css';

const Layout = () => {
  const { user } = useAuth();
  const roleType = getRoleType(user);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = (e) => {
    e.stopPropagation();
    setSidebarOpen(prev => !prev);
  };

  // Auto-close sidebar on route change (mobile)
  useEffect(() => {
    const handleClick = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false);
      }
    };
    document.body.addEventListener('click', handleClick);
    return () => document.body.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="app-container">
      {/* Mobile Nav Bar */}
      <div className="mobile-navbar">
        <button className="hamburger" onClick={toggleSidebar}>
          ☰
        </button>
        <span className="mobile-title">{roleType} Portal</span>
      </div>

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} />

      {/* Main Content Area */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
